import React, { useState } from 'react';
import {
  Container, Row, Col, Button, Form
} from 'react-bootstrap';
import Header from '../Header';
import Footer from '../Footer';
import { Link } from 'react-router-dom';
import { School } from '../../Services/School';
import { NotificationManager } from 'react-notifications';
import ActionButton from '../ActionButton';
import { staticData } from '../../helpers/data';
import { sanitize, validateFormFields } from '../../utils/validationUtils';

const SchoolSignupStepTwo = ({ nextStep, prevStep, handleFormData, handleContactBy, values }) => {
  const [error2, setError2] = useState({});

  const validateForm = () => {
    const sanitizedData = {
      ...Object.keys(values).reduce((acc, key) => {
        acc[key] = sanitize(values[key]);
        return acc;
      }, {})
    };

    const errors = validateFormFields(sanitizedData, 'school');
    setError2(errors);

    if (Object.keys(errors).length > 0) {
      NotificationManager.error(Object.values(errors)[0], 'Form Error', 3000);
      return false;
    }

    return true;
  };

  const submitFormData = (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    if (values.email !== '') {
      School.sendEmail({ email: values.email, in_register: true }).then(
        (data) => {
          if (data.error === 0) {
            NotificationManager.success(data.message, 'success!', 2000);
            nextStep();
          }
        },
        (error) => {
          NotificationManager.error(error.toString(), 'Error!', 2000);
        }
      );
    } else {
      NotificationManager.error('Email is required', 'Error!', 2000);
    }
  };

  return (
    <>
      <Header />
      <section className="login-body" style={{ backgroundImage: 'url(\"images/signup-bg.jpg\")' }}>
        <Container>
          <Row>
            <Col md={12}>
              <div className="step-progress">
                <div className="step-progress-bar">
                  <div className="step-progress-percent" style={{ width: '50%' }}></div>
                </div>
                <div className="step-progress-text">
                  <h6>Profile Creation</h6>
                  <h6>50% Completed</h6>
                </div>
              </div>
            </Col>
          </Row>
          <Row className="justify-content-center">
            <Col md={9}>
              <div className="signup-box">
                <div className="signup-left">
                  <h4>{staticData?.verbiage?.school[2]?.heading}</h4>
                  <p dangerouslySetInnerHTML={{ __html: staticData?.verbiage?.school[2]?.text }} />
                  <div className="signup-step" style={{ marginTop: 260 }}>
                    <ul>
                      <li></li><li className="active"></li><li></li><li></li>
                    </ul>
                  </div>
                </div>
                <div className="signup-right">
                  <Form onSubmit={submitFormData}>
                    <div className="add-details">
                      <Row>
                        <Col md={6}>
                          <Form.Group className="mb-3">
                            <Form.Control type="text" name="first_name" onChange={handleFormData("first_name")} defaultValue={values.first_name} placeholder="Point of contact First Name*" required />
                            <span className="err">{error2?.first_name}</span>
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <Form.Group className="mb-3">
                            <Form.Control type="text" name="last_name" onChange={handleFormData("last_name")} defaultValue={values.last_name} placeholder="Point of contact Last Name*" required />
                            <span className="err">{error2?.last_name}</span>
                          </Form.Group>
                        </Col>
                        <Col md={12}>
                          <Form.Group className="mb-3">
                            <Form.Control type="tel" name="phone" onChange={handleFormData("phone")} defaultValue={values.phone} placeholder="School Main Phone Number" required />
                            <span className="err">{error2?.phone}</span>
                          </Form.Group>
                        </Col>
                        <Col md={12}>
                          <Form.Group className="mb-3">
                            <Form.Control type="email" name="email" onChange={handleFormData("email")} defaultValue={values.email} placeholder="Your School Email Address" required />
                            <span className="err">{error2?.email}</span>
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <Form.Group className="mb-3">
                            <Form.Control type="text" defaultValue={values.school_name} placeholder="School Name" readOnly />
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <Form.Group className="mb-3">
                            <Form.Control type="text" defaultValue={values.school_code} placeholder="School Code" readOnly />
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <Form.Group className="mb-3">
                            <Form.Select name="timezone" onChange={handleFormData("timezone")} defaultValue={values.timezone}>
                              <option disabled value=''>Select Time Zone*</option>
                              <option value="EST">EST</option>
                              <option value="CST">CST</option>
                              <option value="PST">PST</option>
                            </Form.Select>
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <Form.Group className="mb-3">
                            <Form.Control type="text" defaultValue={values.school_street} placeholder="Address" readOnly />
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <Form.Group className="mb-3">
                            <Form.Control type="text" defaultValue={values.school_city} placeholder="City" readOnly />
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <Form.Group className="mb-3">
                            <Form.Control type="text" defaultValue={values.school_state} placeholder="State" readOnly />
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <Form.Group className="mb-3">
                            <Form.Control type="text" defaultValue={values.school_zip} placeholder="Zip Code" readOnly />
                          </Form.Group>
                        </Col>
                        <Col md={12}>
                          <Form.Group className="iagree mb-3" controlId="formbymail">
                            <Form.Check className="text-grey" name="contact_by" type="checkbox" onChange={handleContactBy('contact_by')} checked={values.contact_by.includes('email')} label="Contact Me By Email" value="email" />
                          </Form.Group>
                          <Form.Group className="iagree mb-3" controlId="formbyphone">
                            <Form.Check className="text-grey" name="contact_by" type="checkbox" onChange={handleContactBy('contact_by')} checked={values.contact_by.includes('phone')} label="Contact Me By Phone" value="phone" />
                          </Form.Group>
                        </Col>
                      </Row>
                    </div>
                    <div className="signup-back-btn">
                      <Link onClick={prevStep} to="#" className="btn btn-link">Back</Link>
                      <ActionButton
                        type='submit'
                        className='btn btn-primary btn-pill px-4'
                        title='Create Account'
                        requiredFields={[values?.first_name, values?.last_name, values?.email, values?.phone]}
                      />
                    </div>
                  </Form>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <Footer />
    </>
  );
};

export default SchoolSignupStepTwo;